'use client';

import React from 'react';
import HeroSection from './HeroSection';

import ProgressionShowcase from './ProgressionShowcase';



import Footer from './Footer';

interface HomepageInteractiveProps {
  characterData: {
    name: string;
    title: string;
    level: number;
    itemLevel: number;
    spec: string;
    class: string;
    realm: string;
    guild: string;
    image: string;
    alt: string;
  };
  performanceMetrics: Array<{
    label: string;
    value: string;
    change: string;
    trend: 'up' | 'down' | 'neutral';
    icon: string;
    color: 'frost' | 'blood' | 'silver';
  }>;
  achievements: Array<{
    title: string;
    description: string;
    date: string;
    rarity: 'legendary' | 'epic' | 'rare';
    icon: string;
    progress: number;
  }>;
  builds: Array<{
    name: string;
    type: 'Raid' | 'Mythic+' | 'PvP';
    description: string;
    talents: string[];
    stats: Array<{
      label: string;
      value: string;
    }>;
  }>;
  contactMethods: Array<{
    platform: string;
    handle: string;
    icon: string;
    color: 'frost' | 'blood' | 'silver';
  }>;
  recruitmentStatus: string;
  stickyMetrics: Array<{
    label: string;
    value: string;
    icon: string;
  }>;
}

const HomepageInteractive = ({
  characterData,
  performanceMetrics,
  achievements,
  builds,
  contactMethods,
  recruitmentStatus,
  stickyMetrics,
}: HomepageInteractiveProps) => {
  return (
    <>
      <HeroSection characterData={characterData} />
      <ProgressionShowcase achievements={achievements} />
      <Footer />
    </>
  );
};

export default HomepageInteractive;